import { render, staticRenderFns } from "./RecuperoPassword.vue?vue&type=template&id=09b42f81&scoped=true&"
import script from "./RecuperoPassword.vue?vue&type=script&lang=js&"
export * from "./RecuperoPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecuperoPassword.vue?vue&type=style&index=0&id=09b42f81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b42f81",
  null
  
)

export default component.exports